import React from "react";

const IncidentResponse = () => {
    return (
        <div className="container">
            <h1>Incident Response</h1>
            <p>
                Handle and resolve security incidents swiftly with our comprehensive incident
                response system. Protect your data and systems from active threats.
            </p>
            <p>
                Key capabilities:
                <ul>
                    <li>Rapid threat containment</li>
                    <li>Detailed incident reports</li>
                    <li>Post-incident analysis</li>
                </ul>
            </p>
        </div>
    );
};

export default IncidentResponse;
